import axios from "axios";
import moment from "moment";
import {
    INVENTORY_FETCH_SLUGS_FAILURE,
    INVENTORY_FETCH_SLUGS_START,
    INVENTORY_FETCH_SLUGS_SUCCESS
} from '../actionTypes';
import { slugsSelector } from '../../selectors/slugs';

export function slugsLoadStartAction() {
    return {type: INVENTORY_FETCH_SLUGS_START}
}

export function slugsLoadSuccessAction(slugs, expires) {
    return {type: INVENTORY_FETCH_SLUGS_SUCCESS, payload: {slugs, expires}}
}

export function slugsLoadFailureAction(error) {
    return {type: INVENTORY_FETCH_SLUGS_FAILURE, error}
}

const API_URL = `${process.env.API}/inventory`;
export const SLUG_LOCALSTORAGE_KEY = "REC_GOV_SLUG_CACHE";
const SLUG_CACHE_TTL_IN_DAYS = 7;

function fetchSlugs() {
    return axios.get(`${API_URL}/slugs`);
}

function getExpirationString() {
    return moment().add(SLUG_CACHE_TTL_IN_DAYS, "days").format();
}

function isExpired(expires) {
    return !expires || moment(expires).isBefore();
}

function checkLocalCache(){
    const cache = localStorage.getItem(SLUG_LOCALSTORAGE_KEY);
    return cache ? JSON.parse(cache) : null;
}

function saveToLocalCache(slugs, expires) {
    const cache = {
        slugs,
        expires
    }
    localStorage.setItem(SLUG_LOCALSTORAGE_KEY, JSON.stringify(cache))
}

export function hydrateSlugs() {
    return async (dispatch, getState) => {
        // Check if slugs already hydrated
        const reduxState = slugsSelector(getState());
        if(!isExpired(reduxState?.data?.expires)){
            return;
        }
        dispatch(slugsLoadStartAction());
        const cache  = checkLocalCache();
        if(!isExpired(cache?.expires)) {
            dispatch(slugsLoadSuccessAction(cache.slugs, cache.expires))
            return;
        }
        try {
            const response = await fetchSlugs();
            const expires = getExpirationString();
            saveToLocalCache(response.data, expires);
            dispatch(slugsLoadSuccessAction(response.data, expires))
        } catch (e) {
            dispatch(slugsLoadFailureAction(e));
        }
    }
}
